import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CopartNgComponentsComponent } from './copart-ng-components.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import {TableComponent} from './table/table.component';
import {FiltersComponent} from './filters/filters.component';
import {DateRangeFilterComponent} from './filters/date-range-filter/date-range-filter.component';
import {LoaderComponent} from './loader/loader.component';
import {PhoneNumberIntlComponent} from './intl-phone/phone-number-intl.component';
import {AllowOnly} from './directives/allowOnly';
import {DragdropDirective} from './directives/dragdrop.directive';
import {IntegerOnly} from './directives/IntegerOnly';
import {PrintDirective} from './directives/print.directive';
import {UpperCaseText} from './directives/uppercaseText';
import {CapitalizeFirstPipe} from './pipes/capitalize-first.pipe';
import {CountdownCharsPipe} from './pipes/countdown-chars.pipe';
import {FilterPipe} from './pipes/filter.pipe';
import {PhoneAreaCodePipe, PhonenumberPipe} from './pipes/phonenumber.pipe';
import {YesNoPipe} from './pipes/yes-no.pipe';
import {YmdDatePipe} from './pipes/ymd-date.pipe';
// Prime NG modules
import {TableModule} from 'primeng/table';
import {PanelModule} from 'primeng/panel';
import {PaginatorModule} from 'primeng/paginator';
import {RadioButtonModule} from 'primeng/radiobutton';
import {AccordionModule} from 'primeng/accordion';
import {DropdownModule} from 'primeng/dropdown';
import {CalendarModule} from 'primeng/calendar';
import {KeyFilterModule} from 'primeng/keyfilter';
import {FileUploadModule} from 'primeng/fileupload';
import {DialogModule} from 'primeng/dialog';
import {GrowlModule} from 'primeng/growl';
import {BlockUIModule} from 'primeng/blockui';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {MultiSelectModule} from 'primeng/multiselect';
import {SidebarModule} from 'primeng/sidebar';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {TooltipModule} from 'primeng/tooltip';
import {TreeTableModule} from 'primeng/treetable';

// Material Modules
import {MatDatepickerModule} from '@angular/material/datepicker';
import {InplaceModule} from 'primeng/inplace';
import {
  MatCardModule,
  MatChipsModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatTabsModule
} from '@angular/material';
import {MatMomentDateModule} from '@angular/material-moment-adapter';


import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatExpansionModule} from '@angular/material/expansion';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {UploadDocumentComponent} from "./upload-document/upload-document.component";
import {CustomPicklistComponent} from './custom-picklist/custom-picklist.component';
import { NumberRangeFilterComponent } from './filters/number-range-filter/number-range-filter.component';
import { AgeRangeFilterComponent } from './filters/age-range-filter/age-range-filter.component';

@NgModule({
  declarations: [
    CopartNgComponentsComponent,
    PageNotFoundComponent,
    TableComponent,
    FiltersComponent,
    DateRangeFilterComponent,
    LoaderComponent,
    PhoneNumberIntlComponent,
    AllowOnly,
    DragdropDirective,
    IntegerOnly,
    PrintDirective,
    UpperCaseText,
    CapitalizeFirstPipe,
    CountdownCharsPipe,
    FilterPipe,
    PhonenumberPipe,
    PhoneAreaCodePipe,
    YesNoPipe,
    YmdDatePipe,
    UploadDocumentComponent,
    CustomPicklistComponent,
    NumberRangeFilterComponent,
    AgeRangeFilterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    PanelModule,
    PaginatorModule,
    RadioButtonModule,
    CommonModule,
    AccordionModule,
    DialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    DropdownModule,
    CalendarModule,
    KeyFilterModule,
    FileUploadModule,
    AccordionModule,
    DialogModule,
    MatTabsModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatSelectModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    GrowlModule,
    MatMomentDateModule,
    BlockUIModule,
    ConfirmDialogModule,
    MatMomentDateModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    InplaceModule,
    TooltipModule,
    MatProgressBarModule,
    TreeTableModule,
    MultiSelectModule,
    SidebarModule,
    MatExpansionModule,
    OverlayPanelModule,
    NgbModule,
  ],
  exports: [
    CopartNgComponentsComponent,
    PageNotFoundComponent,
    TableComponent,
    FiltersComponent,
    DateRangeFilterComponent,
    LoaderComponent,
    PhoneNumberIntlComponent,
    AllowOnly,
    DragdropDirective,
    IntegerOnly,
    PrintDirective,
    UpperCaseText,
    CapitalizeFirstPipe,
    CountdownCharsPipe,
    FilterPipe,
    PhonenumberPipe,
    PhoneAreaCodePipe,
    YesNoPipe,
    YmdDatePipe,
    UploadDocumentComponent,
    CustomPicklistComponent
  ]
})
export class CopartNgComponentsModule { }
